export interface IFacets {
    facets: IFacetResult[];
    mobileFacetsVisible: boolean;
    dropdownVisible: boolean;
    selectedFacetCount: number;
}

export interface IFacetResult {
    name: string;
    fieldName: string;
    terms: ITerm[];
    renderTemplate: number;
}

export interface ITerm {
    displayTerm: string;
    fieldName: string;
    term: string;
    hits: number;
    selected: boolean;
    id: number;
    alwaysShow: boolean;
    from: string;
    to: string;
    description: string;
}

export function updateFacetSelected(fieldName: string, termName: string, facetList: IFacetResult[]) {
    if (facetList.filter(f => f.fieldName.toLowerCase() === fieldName) != null && facetList.filter(f => f.fieldName.toLowerCase() === fieldName).length > 0) {
        if (facetList.filter(f => f.fieldName.toLowerCase() === fieldName)[0].terms.filter(t => t.term.toLowerCase() === termName).length > 0) {
            facetList.filter(f => f.fieldName.toLowerCase() === fieldName)[0].terms.filter(t => t.term.toLowerCase() === termName)[0].selected = true;
        }
    }
    return facetList;
}

// Only things that matter in these two facets are the name, fieldName, term and selected
export const englishFacets = [{
    name: "Language",
    fieldName: "Language",
    terms: [{
        displayTerm: "English",
        term: "English",
        hits: 0,
        id: 0,
        selected: true,
        alwaysShow: false,
        from: null,
        to: null
    }]
}] as IFacetResult[];

export const spanishFacets = [{
    name: "Language",
    fieldName: "Language",
    terms: [{
        displayTerm: "Spanish",
        term: "Spanish",
        hits: 0,
        id: 0,
        selected: true,
        alwaysShow: false,
        from: null,
        to: null
    }]
}] as IFacetResult[];

export var FieldNames = Object.freeze({
    Countries: "countries",
    States: "states",
    Subspecialties: "subspecialties",
});
